/**
 * Love Store Paris — Page collection (Phase 3)
 * Filtres rapides + pagination virtuelle (16 produits / page)
 */
(function () {
  'use strict';

  var QUICK_PARAM = 'lsp_quick';
  var QPAGE_PARAM = 'lsp_qpage';
  var productCache = Object.create(null);
  var gridCache = Object.create(null);

  function getQuickFilterFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var value = params.get(QUICK_PARAM);
    if (value === 'promo' || value === 'new') return value;
    return 'all';
  }

  function getVirtualPageFromUrl() {
    var page = parseInt(new URLSearchParams(window.location.search).get(QPAGE_PARAM), 10);
    return page > 0 ? page : 1;
  }

  function setQuickFilterInUrl(filter, virtualPage) {
    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete(QPAGE_PARAM);

    if (filter === 'all') {
      url.searchParams.delete(QUICK_PARAM);
    } else {
      url.searchParams.set(QUICK_PARAM, filter);
      if (virtualPage && virtualPage > 1) {
        url.searchParams.set(QPAGE_PARAM, String(virtualPage));
      }
    }

    window.history.replaceState({}, '', url.toString());
  }

  function getPerPage(root) {
    return parseInt(root.dataset.lspPerPage, 10) || 16;
  }

  function getCounts(root) {
    var grid = root.querySelector('.lsp-collection__grid');
    return {
      collection: parseInt(root.dataset.lspCollectionCount, 10) || 0,
      all: parseInt(root.dataset.lspCollectionAll, 10) || 0,
      page: grid ? parseInt(grid.dataset.lspPageCount, 10) || 0 : 0
    };
  }

  function pluralize(count) {
    return count === 1 ? 'produit' : 'produits';
  }

  function renderCollectionCount(countEl, counts) {
    if (!countEl) return;
    var label = pluralize(counts.collection);
    if (counts.collection === counts.all) {
      countEl.innerHTML = '<strong>' + counts.collection + '</strong> ' + label;
    } else {
      countEl.innerHTML =
        '<strong>' + counts.collection + '</strong> ' + label + ' sur ' + counts.all;
    }
  }

  function renderQuickFilterCount(countEl, matchTotal, collectionTotal, filter) {
    if (!countEl) return;
    var label = pluralize(matchTotal);
    var suffix = filter === 'promo' ? ' en promo' : ' nouveautés';
    countEl.innerHTML = '<strong>' + matchTotal + '</strong> ' + label + suffix;
    if (matchTotal < collectionTotal) {
      countEl.innerHTML +=
        ' <span class="lsp-collection__count-note">sur ' + collectionTotal + '</span>';
    }
  }

  function isProductPromo(product) {
    return (product.variants || []).some(function (variant) {
      var price = parseFloat(variant.price);
      var compare = parseFloat(variant.compare_at_price);
      return !isNaN(price) && !isNaN(compare) && compare > price && price > 0;
    });
  }

  function filterGridItemsByQuick(allItems, filter) {
    if (filter === 'promo') {
      return allItems.filter(function (item) {
        return item.getAttribute('data-lsp-promo') === 'true';
      });
    }

    if (filter === 'new') {
      return allItems.filter(function (item) {
        return item.getAttribute('data-lsp-new') === 'true';
      });
    }

    return allItems;
  }

  function isProductNew(product) {
    var hasNewTag = (product.tags || []).some(function (tag) {
      var value = String(tag).toLowerCase();
      return value === 'nouveau' || value === 'new';
    });
    if (hasNewTag) return true;

    var dateStr = product.published_at || product.created_at;
    if (!dateStr) return false;

    var published = new Date(dateStr).getTime();
    if (isNaN(published)) return false;

    var sixMonthsMs = 180 * 24 * 60 * 60 * 1000;
    return Date.now() - published < sixMonthsMs;
  }

  function fetchAllCollectionProducts(handle) {
    if (productCache[handle]) return productCache[handle];

    productCache[handle] = (function loadPage(page, acc) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (response) {
          if (!response.ok) throw new Error('products.json failed');
          return response.json();
        })
        .then(function (data) {
          var batch = data.products || [];
          var merged = acc.concat(batch);
          if (batch.length === 250) return loadPage(page + 1, merged);
          return merged;
        });
    })(1, []).catch(function () {
      delete productCache[handle];
      return [];
    });

    return productCache[handle];
  }

  function buildMatchingIds(products, filter) {
    var ids = new Set();
    products.forEach(function (product) {
      var match = filter === 'promo' ? isProductPromo(product) : isProductNew(product);
      if (match) ids.add(String(product.id));
    });
    return ids;
  }

  function buildCollectionPageUrl(handle, page) {
    var url = new URL('/collections/' + handle, window.location.origin);
    var current = new URL(window.location.href);

    current.searchParams.forEach(function (val, key) {
      if (key !== 'page' && key !== QUICK_PARAM && key !== QPAGE_PARAM) {
        url.searchParams.set(key, val);
      }
    });

    if (page > 1) url.searchParams.set('page', String(page));
    return url.toString();
  }

  function sanitizeGridItem(item) {
    item.querySelectorAll('quick-add-modal').forEach(function (el) {
      el.remove();
    });

    item.querySelectorAll('modal-opener[data-modal^="#QuickAdd-"]').forEach(function (opener) {
      opener.setAttribute('data-modal', '#LspCollectionQuickAdd');
    });

    return item;
  }

  function cleanupOrphanQuickAddModals() {
    document.querySelectorAll('quick-add-modal').forEach(function (modal) {
      if (modal.id !== 'LspCollectionQuickAdd') modal.remove();
    });
  }

  function fetchAllGridItems(handle, root) {
    var counts = getCounts(root);
    var perPage = getPerPage(root);
    var totalPages = Math.max(1, Math.ceil(counts.collection / perPage));
    var cacheKey = handle + '::pages=' + totalPages;

    if (gridCache[cacheKey]) return gridCache[cacheKey];

    var requests = [];
    for (var p = 1; p <= totalPages; p++) {
      requests.push(
        fetch(buildCollectionPageUrl(handle, p)).then(function (response) {
          return response.text();
        })
      );
    }

    gridCache[cacheKey] = Promise.all(requests).then(function (htmlPages) {
      var parser = new DOMParser();
      var items = [];

      htmlPages.forEach(function (html) {
        var doc = parser.parseFromString(html, 'text/html');
        doc.querySelectorAll('.lsp-collection__grid-item').forEach(function (el) {
          items.push(sanitizeGridItem(el.cloneNode(true)));
        });
      });

      return items;
    });

    return gridCache[cacheKey];
  }

  function togglePaginationMode(root, virtual) {
    var serverPagination = root.querySelector('[data-lsp-server-pagination]');
    var virtualPagination = root.querySelector('[data-lsp-virtual-pagination]');
    if (serverPagination) serverPagination.hidden = virtual;
    if (virtualPagination) virtualPagination.hidden = !virtual;
    root.dataset.lspVirtualActive = virtual ? 'true' : 'false';
  }

  function initCartForms(root) {
    root.querySelectorAll('[data-type="add-to-cart-form"]').forEach(function (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;
    });
  }

  function scrollToCollectionTop(root) {
    var chromeOffset = 16;
    try {
      var raw = getComputedStyle(document.documentElement).getPropertyValue('--lsp-chrome-offset');
      var parsed = parseInt(raw, 10);
      if (!isNaN(parsed)) chromeOffset = parsed + 16;
    } catch (e) {
      /* ignore */
    }

    var target =
      root.querySelector('.lsp-collection__breadcrumb') ||
      root.querySelector('.lsp-collection__header') ||
      root;
    var top = target.getBoundingClientRect().top + window.pageYOffset - chromeOffset;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function renderVirtualPagination(root, totalItems, currentPage, perPage, filter) {
    var nav = root.querySelector('[data-lsp-virtual-pagination]');
    if (!nav) return;

    var totalPages = Math.max(1, Math.ceil(totalItems / perPage));
    currentPage = Math.min(Math.max(currentPage, 1), totalPages);

    if (totalPages <= 1) {
      nav.innerHTML = '';
      nav.hidden = true;
      return;
    }

    nav.hidden = false;
    var html = '<div class="pagination-wrapper"><ul class="pagination__list list-unstyled" role="list">';

    if (currentPage > 1) {
      html +=
        '<li><button type="button" class="pagination__item pagination__item-arrow link" data-lsp-vpage="' +
        (currentPage - 1) +
        '" aria-label="Page précédente">‹</button></li>';
    }

    for (var i = 1; i <= totalPages; i++) {
      if (i === currentPage) {
        html +=
          '<li><span class="pagination__item pagination__item--current" aria-current="page">' +
          i +
          '</span></li>';
      } else {
        html +=
          '<li><button type="button" class="pagination__item link" data-lsp-vpage="' +
          i +
          '">' +
          i +
          '</button></li>';
      }
    }

    if (currentPage < totalPages) {
      html +=
        '<li><button type="button" class="pagination__item pagination__item-arrow link" data-lsp-vpage="' +
        (currentPage + 1) +
        '" aria-label="Page suivante">›</button></li>';
    }

    html += '</ul></div>';
    nav.innerHTML = html;

    nav.querySelectorAll('[data-lsp-vpage]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var nextPage = parseInt(btn.getAttribute('data-lsp-vpage'), 10);
        renderVirtualPage(root, nextPage, filter);
      });
    });
  }

  function renderVirtualPage(root, page, filter) {
    var state = root._lspVirtual;
    if (!state) return;

    var perPage = state.perPage;
    var totalPages = Math.max(1, Math.ceil(state.items.length / perPage));
    page = Math.min(Math.max(page, 1), totalPages);

    var grid = root.querySelector('.lsp-collection__grid');
    var emptyEl = root.querySelector('[data-lsp-quick-empty]');
    var hintEl = root.querySelector('[data-lsp-page-hint]');
    if (!grid) return;

    var start = (page - 1) * perPage;
    var slice = state.items.slice(start, start + perPage);

    grid.innerHTML = '';
    cleanupOrphanQuickAddModals();
    slice.forEach(function (item) {
      grid.appendChild(sanitizeGridItem(item.cloneNode(true)));
    });
    initCartForms(root);

    grid.hidden = slice.length === 0;
    if (emptyEl) emptyEl.hidden = slice.length > 0;
    if (hintEl) hintEl.hidden = true;

    state.page = page;
    setQuickFilterInUrl(filter, page);
    renderVirtualPagination(root, state.items.length, page, perPage, filter);
    scrollToCollectionTop(root);
  }

  function applyQuickFilter(root, filter) {
    var counts = getCounts(root);
    var countEl = root.querySelector('[data-lsp-count]');
    var hintEl = root.querySelector('[data-lsp-page-hint]');
    var handle = root.dataset.collectionHandle;
    var perPage = getPerPage(root);

    root.querySelectorAll('[data-lsp-quick-filter]').forEach(function (chip) {
      chip.classList.toggle('is-active', chip.getAttribute('data-lsp-quick-filter') === filter);
    });

    root.dataset.lspQuickFilter = filter;

    if (filter === 'all') {
      if (root.dataset.lspVirtualActive === 'true') {
        var url = new URL(window.location.href);
        url.searchParams.delete(QUICK_PARAM);
        url.searchParams.delete(QPAGE_PARAM);
        url.searchParams.delete('page');
        window.location.href = url.toString();
        return;
      }

      togglePaginationMode(root, false);
      if (hintEl) hintEl.hidden = true;
      setQuickFilterInUrl('all');
      renderCollectionCount(countEl, counts);
      return;
    }

    if (!handle) return;

    togglePaginationMode(root, true);
    if (countEl) countEl.textContent = 'Chargement…';
    if (hintEl) hintEl.hidden = true;

    Promise.all([fetchAllGridItems(handle, root)]).then(function (results) {
        if (root.dataset.lspQuickFilter !== filter) return;

        var allItems = results[0];
        var filteredItems = filterGridItemsByQuick(allItems, filter);

        root._lspVirtual = {
          filter: filter,
          items: filteredItems,
          page: 1,
          perPage: perPage
        };

        renderQuickFilterCount(countEl, filteredItems.length, counts.collection, filter);
        renderVirtualPage(root, getVirtualPageFromUrl(), filter);
      }
    );
  }

  function initQuickFilters(root) {
    var wrap = root.querySelector('[data-lsp-quick-filters]');
    if (!wrap || wrap.dataset.lspQuickInit === 'true') return;
    wrap.dataset.lspQuickInit = 'true';

    wrap.querySelectorAll('[data-lsp-quick-filter]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        applyQuickFilter(root, chip.getAttribute('data-lsp-quick-filter') || 'all');
      });
    });

    root.querySelectorAll('[data-lsp-quick-reset]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyQuickFilter(root, 'all');
      });
    });

    applyQuickFilter(root, getQuickFilterFromUrl());
  }

  function closePanels(toolbar, except) {
    toolbar.querySelectorAll('[data-lsp-panel]').forEach(function (panel) {
      if (panel === except) return;
      panel.hidden = true;
    });
    toolbar.querySelectorAll('[data-lsp-toggle]').forEach(function (btn) {
      if (except && btn.getAttribute('aria-controls') === except.id) return;
      btn.setAttribute('aria-expanded', 'false');
      btn.classList.remove('is-open');
    });
  }

  function initToolbar(toolbar, root) {
    if (!toolbar || toolbar.dataset.lspToolbarInit === 'true') return;
    toolbar.dataset.lspToolbarInit = 'true';

    toolbar.querySelectorAll('[data-lsp-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('aria-controls');
        var panel = targetId ? document.getElementById(targetId) : null;
        if (!panel) return;

        var willOpen = panel.hidden;
        closePanels(toolbar);
        if (willOpen) {
          panel.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
          btn.classList.add('is-open');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!toolbar.contains(e.target)) closePanels(toolbar);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanels(toolbar);
    });

    initQuickFilters(root);
  }

  function initCollection(root) {
    if (!root || root.dataset.lspCollectionInit === 'true') return;
    root.dataset.lspCollectionInit = 'true';

    cleanupOrphanQuickAddModals();

    var toolbar = root.querySelector('[data-lsp-toolbar]');
    if (toolbar) initToolbar(toolbar, root);
    else initQuickFilters(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-lsp-collection]').forEach(initCollection);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-lsp-collection]');
    if (el) initCollection(el);
  });
})();
